
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const SECURITY_QUESTIONS = [
  "What was the name of your first pet?",
  "In which city were you born?",
  "What was your mother's maiden name?",
  "What was the name of your first school?",
  "What was your childhood nickname?",
  "What is your favorite book of all time?",
  "What street did you grow up on?",
  "What was the make of your first car?",
  "What is your father's middle name?",
  "What was your high school mascot?"
];

interface SecurityQuestionsProps {
  securityQuestion: string;
  setSecurityQuestion: (value: string) => void;
  securityAnswer: string;
  setSecurityAnswer: (value: string) => void;
  isLoading: boolean;
}

export function SecurityQuestions({
  securityQuestion,
  setSecurityQuestion,
  securityAnswer,
  setSecurityAnswer,
  isLoading
}: SecurityQuestionsProps) {
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="securityQuestion">Security Question</Label>
        <Select
          value={securityQuestion}
          onValueChange={setSecurityQuestion}
          disabled={isLoading}
        >
          <SelectTrigger className="w-full">
            <SelectValue placeholder="Select a security question" />
          </SelectTrigger>
          <SelectContent>
            {SECURITY_QUESTIONS.map((question) => (
              <SelectItem key={question} value={question}>
                {question}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label htmlFor="securityAnswer">Security Answer</Label>
        <Input
          id="securityAnswer"
          value={securityAnswer}
          onChange={(e) => setSecurityAnswer(e.target.value)}
          type="text"
          placeholder="Enter your answer"
          required
          className="w-full"
          disabled={isLoading}
        />
      </div>
    </>
  );
}
